import Axios from 'config/service.config'
import config from 'config/env_config'

export const getPurchasedPackages = async ({ status, skip, limit }) => {
  try {
    const { data } = await Axios({
      baseURL: config.scheduling,
      url: '/purchased-packages',
      method: 'get',
      withCredentials: true,
      params: { status, sortBy: 'createdAt', orderBy: -1, skip, limit }
    })
    return { success: true, data }
  } catch (error) {
    return { success: false, error: error.response }
  }
}

export const getPurchasedPackageById = async ({ id }) => {
  try {
    const data = await Axios({
      baseURL: config.scheduling,
      url: `/purchased-packages/${id}`,
      method: 'get',
      withCredentials: true
    })
    return data
  } catch (error) {
    return { success: false, error: error.response }
  }
}

export const requestCancel = async ({ id, cancellationDetails }) => {
  const data = await Axios({
    baseURL: config.scheduling,
    url: `/purchased-packages/request-cancel/${id}`,
    method: 'post',
    withCredentials: true,
    data: {
      cancellationDetails
    }
  })

  return data
}
